import BaseDate from 'nast-date'
import moment from 'moment-timezone'
import get from 'lodash/get'

/**
 *
 */
export default class NastDate extends BaseDate {
  // eslint-disable-next-line require-jsdoc
  format(datetime = undefined, type = undefined, useOld = false) {
    if (!type) {
      type = this._config('default')
    }
    const timezones = [ 'Asia/Nur-Sultan', 'Asia/Almaty', 'Asia/Astana', 'Asia/Qyzylorda', 'Asia/Aqtau', 'Asia/Oral', ]
    const selectedTimezone = JSON.parse(localStorage.getItem('selectedTimezone'))
    if ($app.auth.user().companyId === 415) {
      datetime = moment.tz(datetime, selectedTimezone?.included[0] ||'Asia/Aqtobe')
    } else {
      if (timezones.includes(Intl.DateTimeFormat().resolvedOptions().timeZone) && !useOld) {
        datetime = moment.tz(datetime, selectedTimezone?.included[0] ||'Asia/Aqtobe')
      } else {
        datetime = moment.tz(datetime, selectedTimezone?.included[0]||Intl.DateTimeFormat().resolvedOptions().timeZone)
      }
    }
    if (!datetime._i) return ''
    return datetime.format(get(this._config('formats'), type, this._defaultFormat()))
  }
}
